import { useEffect, useState } from 'react';

export function useDeviceType() {
  const [deviceType, setDeviceType] = useState('desktop'); // 'mobile' | 'tablet' | 'desktop'

  useEffect(() => {
    const detectDevice = () => {
      const ua = navigator.userAgent.toLowerCase();

      if (/mobile|iphone|ipod|android.*mobile|blackberry|iemobile|opera mini/.test(ua)) {
        return 'mobile';
      } else if (/ipad|tablet|android(?!.*mobile)/.test(ua)) {
        return 'tablet';
      } else {
        return 'desktop';
      }
    };

    setDeviceType(detectDevice());
  }, []);

  return deviceType;
}
